export default {fields:{plateSchemaType:{},containerSchemaId:{},height:{},width:{}},spreads:{BaseStorableSchema:{}}}